import { Form } from "react-bootstrap";
import { useContext } from "react";
import { OrcamentoVendaContext } from "../../contexts/orcamentovenda-context";
import ListComp2 from "../../common/listcomp2";

const OrcamentoVendaCondicoesEspeciaisCtx = (props) => {

    const {
        orcamentoVenda,
        constantes
    } = useContext(OrcamentoVendaContext);

    const columns = [
        {
            field: 'DataHoraInclusao',
            headerName: 'Data Inclusao',
            type: "date",
            format: "dd/MM/yyyyy",
        },
        {
            field: 'UsuarioInclusaoLogin',
            headerName: 'User',
        },

        {
            field: 'PercentualDescontoEspecial',
            headerName: '%',
        },
        {
            field: 'Justificativa',
            headerName: 'Justificativa',
        },
    ];

    return (
        <>
            <Form.Label>
              {constantes.CondicoesEspeciaisAplicadas}
            </Form.Label>
            <ListComp2
                semcontainer
                columns={columns}
                msgAviso={false}
                data={orcamentoVenda?.CondicoesEspeciais}
            />
        </>
    )
}

export default OrcamentoVendaCondicoesEspeciaisCtx;